import { useEffect, useState } from "react";
import "./CourseAds.scss";
const CourseAds = (props) => {
  return (
    <>
      <div className="ads-wrapper d-flex gap-4 flex-column mt-4 mb-4 align-items-center">
        <div className="ads">
          <img src="/images/righ_pannel_banner1.png" className="img-fluid" alt="ads" />
          {/* <div className="clickhere"></div> */}
        </div>
        <div className="ads">
          <img src="/images/righ_pannel_banner2.png" className="img-fluid" alt="ads" />
          {/* <div className="clickhere"></div> */}
        </div>
      </div>
    </>
  );
};

export default CourseAds;
